function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { createSlice } from '@reduxjs/toolkit';
import { eSignalResource } from '../../../resources/ESignal.resource';
var initialState = {
    data: []
};
export var ESignalReducer = createSlice({
    name: 'eSignal',
    initialState: initialState,
    reducers: {
        init: function init(state, payloadAction) {
            var data = [];
            payloadAction.payload.forEach(function (item) {
                data[item.id] = eSignalResource(item);
            });
            state.data = data;
        },
        add: function add(state, payloadAction) {
            var eSignal = eSignalResource(payloadAction.payload);
            state.data[eSignal.id] = eSignal;
        },
        update: function update(state, payloadAction) {
            var eSignal = eSignalResource(payloadAction.payload);
            state.data[eSignal.id] = eSignal;
        },
        updateStatus: function updateStatus(state, payloadAction) {
            var statuses = payloadAction.payload;
            state.data = state.data.map(function (item) {
                var status = statuses.find(function (status) {
                    return status.id === item.id;
                });
                return status ? _objectSpread(_objectSpread({}, item), {}, {
                    statuses: status.statuses
                }) : item;
            });
        }
    }
});
var _ESignalReducer$actio = ESignalReducer.actions, add = _ESignalReducer$actio.add, init = _ESignalReducer$actio.init, update = _ESignalReducer$actio.update, updateStatus = _ESignalReducer$actio.updateStatus;
export { add, init, update, updateStatus };
export default ESignalReducer.reducer;
